const FreeWriteBuilderEnum = {
  FREE_WRITE_BUILDER_DOCUMENT_CONTENT_GET_REQUEST: 'FREE_WRITE_BUILDER_DOCUMENT_CONTENT_GET_REQUEST',
  FREE_WRITE_BUILDER_DOCUMENT_CONTENT_GET_SUCCESS: 'FREE_WRITE_BUILDER_DOCUMENT_CONTENT_GET_SUCCESS',
  FREE_WRITE_BUILDER_DOCUMENT_CONTENT_GET_FAILURE: 'FREE_WRITE_BUILDER_DOCUMENT_CONTENT_GET_FAILURE',
};

export default FreeWriteBuilderEnum;



// WEBPACK FOOTER //
// ./src-react/FreeWriteBuilder/FreeWriteBuilderConstants.jsx